<template>
    <div class="IsJoinLowPv" v-if="isShow && payAmount >= showAmount">
        <el-radio class="radio-item" v-model="isJoin" label="1" border>{{ $t('JoinLowPvEvent') }}</el-radio>
        <div style="margin: 5px 0;" />
        <el-radio class="radio-item" v-model="isJoin" label="0" border>{{ $t('UnJoinLowPvEvent') }}</el-radio>
    </div>
</template>

<script>
import { getConfig } from "@/api/member"
export default {
    name: 'IsJoinLowPv',
    props: {
        payAmount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            showAmount: 0, // 达到此金额展示组件
            isShow: false, // 是否展示
            isJoin: ''
        };
    },
    async created() {
        try {
            let res = await getConfig({ config: 'JoinLowPVBonusPromotionAmount' })
            let [showAmount, isShow] = res.data.split('-')
            this.isShow = isShow === '1'
            this.showAmount = Number(showAmount)
            console.log(showAmount, 'showAmount');
            console.log(isShow === '1', 'isShow');
            // this.$emit('isJoinLowPv', )
        } catch (error) {
            console.error(error);
        }
    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>
.IsJoinLowPv {
    text-align: left;
    margin: 5px 0;
}

.radio-item {
    margin: 0 0 0 50px;
}
</style>
